import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { DirSaleLineList } from '@/sc/entities/dirSaleLine/DirSaleLineList';

export const DirSaleDetail = () => {
  
  const { entityObj } = useEntityMgr();
  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'dirSaleLine', label: 'Lines', content: <DirSaleLineList dirSaleObj={entityObj}/>},
  ];


  return (
    <EntityDetail tabSpecs={tabSpecs}/>
  )
}